import { UseMutationOptions } from 'react-query';
import { CuredApiPaths } from '../../models/enums';
import { ABTestConfig } from 'domains/campaigns/types';
import useMutation from '../useMutation';
import MutationKeys from './keys';

export type GetABTestInsightsInput = {
    campaignId: string;
};

export type ABTestInsightMetrics = {
    send_id: number;
    total_sent: string;
    total_delivered: string;
    delivered_rate: string;
    total_opened: string;
    unique_opened: string;
    open_rate: string;
    unique_open_rate: string;
    total_clicked: string;
    unique_clicked: string;
    click_rate: string;
    unique_click_rate: string;
};

export type GetABTestInsightsResponse = {
    campaignId: string;
    campaignName: string;
    abTestConfig: ABTestConfig;
    abTestInsights: Record<string, ABTestInsightMetrics>;
};

/**
 * Fetches A/B test insights for a campaign.
 * @param mutateOptions react-query useMutation option
 * @returns the react-query useMutation results
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useGetABTestInsights = (
    mutateOptions?: UseMutationOptions<GetABTestInsightsResponse, Error, GetABTestInsightsInput>
) =>
    useMutation<GetABTestInsightsInput, GetABTestInsightsResponse>(
        MutationKeys.GET_AB_TEST_INSIGHTS,
        CuredApiPaths.CAMPAIGNS_AB_TEST_INSIGHTS,
        mutateOptions
    );

export default useGetABTestInsights;
